import React from "react";
import FormType from "../../../../../shared/components/FormType";
import { basicFields } from "../../../../../configs/provider";
import {PageContentWrapper} from "../../../../../shared/styled/PageContentStyle";

interface ContactPersonProps {
  onChangeContactPerson: Function;
  validated: boolean;
}

const ContactPerson = ({
  onChangeContactPerson,
  validated,
}: ContactPersonProps) => {
  return (
    <PageContentWrapper>
      <FormType
        title={"Thông tin nhà cung cấp"}
        mergeFormData={onChangeContactPerson}
        fields={basicFields}
        validated={validated}
      />
    </PageContentWrapper>
  );
};

export default ContactPerson;
